export default {
  isVideo (url) {
    const ext = url.split('.').pop()
    return (ext === 'mp4')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fileHelpers.js